// extracted by mini-css-extract-plugin
export default {"title":"DrinkIngredients_title__EVWx-","drink_ingredients":"DrinkIngredients_drink_ingredients__c7aaS","drink_ingredient":"DrinkIngredients_drink_ingredient__xkrPG"};